import { useCallback, useState } from "react";
import type { VehicleDocument } from "@/features/vehicle/types/vehicle-document.types";

export function useVehicleDocumentDrawerHandler() {
	const [isOpen, setDrawerOpen] = useState(false);
	const [editingDocument, setEditingDocument] =
		useState<VehicleDocument | null>(null);

	const openForNew = useCallback(() => {
		setEditingDocument(null);
		setDrawerOpen(true);
	}, []);

	const openForEdit = useCallback((doc: VehicleDocument) => {
		setEditingDocument(doc);
		setDrawerOpen(true);
	}, []);

	const close = useCallback(() => {
		setDrawerOpen(false);
		setEditingDocument(null);
	}, []);

	return { isOpen, editingDocument, openForNew, openForEdit, close };
}
